import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { hideElevenLabsBranding } from "@/lib/elevenlabs-branding";
import {
  ensureElevenLabsConvaiScript,
  hasHelpChatConsent,
  rememberHelpChatConsent,
} from "@/lib/elevenlabsConvai";

const HELP_AGENT_ID = "agent_5801kh9y69h3fckary2r5vwz2x81";

export function ElevenLabsWidget() {
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!active) return;

    ensureElevenLabsConvaiScript();

    const widget = document.createElement("elevenlabs-convai");
    widget.setAttribute("agent-id", HELP_AGENT_ID);
    document.body.appendChild(widget);

    const cleanup = hideElevenLabsBranding(widget);

    return () => {
      cleanup();
      widget.remove();
    };
  }, [active]);

  const openHelp = () => {
    if (hasHelpChatConsent()) {
      setActive(true);
      return;
    }
    setNoticeOpen(true);
  };

  const acceptAndLoad = () => {
    rememberHelpChatConsent();
    setNoticeOpen(false);
    setActive(true);
  };

  return (
    <>
      {!active && (
        <Button
          type="button"
          onClick={openHelp}
          className="fixed bottom-6 right-6 z-50 h-14 rounded-full px-5 shadow-lg"
        >
          Help
        </Button>
      )}

      <AlertDialog open={noticeOpen} onOpenChange={setNoticeOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Help chat</AlertDialogTitle>
            <AlertDialogDescription>
              This chat is provided by ElevenLabs (USA). ElevenLabs receives
              your IP address, browser details and, if you use voice, your
              voice and conversation.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Not now</AlertDialogCancel>
            <AlertDialogAction onClick={acceptAndLoad}>Continue</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
